// The authenticated home. Waiting on you is where a signed-in person lands:
// one inbox across every Team, the asks addressed to them (Oct 2026 shell).
export const AUTHENTICATED_DEFAULT_PATH = "/waiting";
